import React from 'react';
import { useLocation } from 'wouter';
import { Button } from '@/components/ui/button';
import { useAuth0 } from '@auth0/auth0-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { AlertCircle, Home, LogIn } from 'lucide-react';

const UnauthorizedPage: React.FC = () => {
  const [, setLocation] = useLocation();
  const { loginWithRedirect } = useAuth0();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <Card className="max-w-md mx-auto">
        <CardHeader className="text-center">
          <AlertCircle className="h-12 w-12 text-red-600 mx-auto mb-4" />
          <CardTitle className="text-red-700">Access Denied</CardTitle>
          <CardDescription>
            You don't have permission to access this project or resource.
          </CardDescription>
        </CardHeader>
        
        <CardContent className="space-y-4">
          <div className="text-sm text-gray-600 text-center">
            <p>If you believe this is an error, please:</p>
            <ul className="mt-2 space-y-1">
              <li>• Check that you're logged in with the correct account</li>
              <li>• Verify you have the necessary project permissions</li>
              <li>• Contact your project administrator for access</li>
            </ul>
          </div>

          <div className="flex flex-col gap-2">
            <Button 
              onClick={() => setLocation('/')}
              className="w-full"
            >
              <Home className="h-4 w-4 mr-2" />
              Go to Dashboard
            </Button>
            
            <Button 
              variant="outline"
              onClick={() => loginWithRedirect()}
              className="w-full"
            >
              <LogIn className="h-4 w-4 mr-2" />
              Login with Different Account
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default UnauthorizedPage;
